import Vue from 'vue';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    name: 'improveSafetyPopupChunk',
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    methods: {
        toAccount() {
            window.open(getPassportUrl('/id/', { withAcceptor: true }), '_blank');
        },
        getContent() {
            const result = [];
            if (this.slotData.isKycBasic)
                result.push('пройдите верификацию');
            if (this.slotData.hasnt2FAOnEnter)
                result.push('подключите двухфакторную аутентификацию');
            return result.join(', ');
        }
    }
});
